import Vue from 'vue'

export default [
  {
    path: '/bulletin/',
    component: () => import('@/components/Layer.vue'),
    children: [
      {
        path: '',
        name: 'BulletinIndex',
        component: () => import('@/views/Bulletin/index.vue'),
        meta: {
          prev: 'goHome'
        }
      },
      {
        path: 'new',
        name: 'BulletinLayoutNew',
        component: () => import('@/views/Bulletin/layout/index.vue'),
        meta: {
          prev: 'BulletinIndex'
        }
      },
      {
        path: 'settings',
        name: 'BulletinSettings',
        component: () => import('@/views/Bulletin/settings/index.vue'),
        meta: {
          prev: 'BulletinIndex'
        }
      },
      {
        path: 'emergency',
        name: 'BulletinEmergency',
        component: () => import('@/views/Bulletin/emergency/index.vue'),
        meta: {
          prev: 'BulletinIndex'
        }
      },
      {
        path: ':id',
        name: 'BulletinLayoutId',
        component: () => import('@/views/Bulletin/layout/index.vue'),
        meta: {
          prev: 'BulletinIndex'
        }
      }
    ],
    beforeEnter: async (to, from, next) => {
      try {
        const allow = Vue.prototype.$isServiceEnabled(21)
        if (allow) {
          next()
        } else {
          Vue.prototype
            .$alert('未啟用電子看板服務', '警告', {
              confirmButtonText: '確定',
              type: 'warning',
              showClose: false,
              roundButton: true,
              closeOnClickModal: false
            })
            .then(() => {
              Vue.prototype.$toMainPage()
              return false
            })
        }
      } catch (error) {
        console.log('Bulletin beforeEnter error', error)
        Vue.prototype
          .$alert('伺服器發生錯誤，請重新再試', '警告', {
            confirmButtonText: '確定',
            type: 'warning',
            showClose: false,
            roundButton: true,
            closeOnClickModal: false
          })
          .then(() => {
            Vue.prototype.$toMainPage()
            return false
          })
      }
    }
  }
]
